import Button from "@src/app/components/Button/Button";
import Link from "@src/app/components/Link";
import type { ReactElement } from "react";

interface Props {
  theme?: "light" | "dark";
  icon: ReactElement;
  mediaType: string;
  onClick?: () => void;
}

export default function SocialShareButton({
  theme = "light",
  icon,
  mediaType,
  onClick,
}: Props): ReactElement {
  return (
    <Link
      to=""
      className={`a2a_button_${mediaType}`}
      aria-label={`Share on ${mediaType}`}
      onClick={onClick}
    >
      <Button
        variant={theme === "light" ? "tertiary" : "secondary"}
        size="medium"
        icon={icon}
        className="w-full"
      />
    </Link>
  );
}
